import { Injectable } from "@angular/core";
import {
  SignalR,
  ISignalRConnection,
  BroadcastEventListener,
  IConnectionOptions,
  ConnectionStatus,
  ConnectionStatuses
} from "ng2-signalr";
import { environment } from "../../environments/environment";

const URL = environment.apiBaseUrl;

@Injectable()
export class SignalrService {
  // connection: SignalRConnection;
  connection: ISignalRConnection;
  msgReceiver: BroadcastEventListener<string>;
  retFunc: Function;
  isConnected = false;

  constructor(private signalR: SignalR) {}

  public start(retFunc: Function): void {
    this.retFunc = retFunc;

    const config: IConnectionOptions = {
      hubName: "Ng2SignalRHub",
      url: URL,
      qs: { access_token: localStorage.getItem("access_token") }
    };
    this.signalR.connect(config).then(connection => {
      this.msgReceiver = new BroadcastEventListener<any>("broadcastMessage");
      this.connection = connection;
      this.connection.start().then(x => {
        this.isConnected = true;
        this.connection.listen(this.msgReceiver);
        this.msgReceiver.subscribe((msg: any) => {
          this.retFunc(msg);
        });
      });
      this.connection.status.subscribe((val: ConnectionStatus) => {
        if (
          val.equals(ConnectionStatuses.disconnected) &&
          this.isConnected === true
        ) {
          // client thinks it should be connected but it isn't
          console.log("signalr reconnecting...");
          this.connection.start().then(x => {
            this.connection.listen(this.msgReceiver);
            this.msgReceiver.subscribe((msg: any) => {
              this.retFunc(msg);
            });
          });
        }
      });
    });
  }

  public stop(): void {
    this.isConnected = false;
    this.connection.stop();
    this.msgReceiver.unsubscribe();
  }
}
